import { createSelector } from 'reselect';
import _get from 'lodash/get';

import { getActivityTypes } from 'lib/selectors/getActivityTypes';
import { ACTIVITY_MODES } from 'lib/constants';

const defaultRefs = [];

const getActiveSetupActivityTypeRefs = createSelector(
  [getActivityTypes],
  (activityTypes = []) => {
    if (!_get(activityTypes, 'length')) {
      return defaultRefs;
    }
    return activityTypes.reduce(
      (setupActivityTypeRefs, { activityMode, activityTypeRef }) => {
        if (activityMode === ACTIVITY_MODES.SETUP) {
          return [...setupActivityTypeRefs, activityTypeRef];
        }
        return setupActivityTypeRefs;
      },
      []
    );
  }
);

export { getActiveSetupActivityTypeRefs };
